import { render, staticRenderFns } from "./today.vue?vue&type=template&id=5a2f3279&"
import script from "./today.vue?vue&type=script&lang=js&"
export * from "./today.vue?vue&type=script&lang=js&"
import style0 from "./today.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports